import React, { Component } from 'react';
import UserDeviceContractsList from 'components/UserDeviceContractsList/UserDeviceContractsList';
import Pagination from 'components/Pagination/Pagination';

class UserDeviceContracts extends Component {
  componentDidMount() {
    this.fetchUserDeviceContracts();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.userId !== this.props.userId) {
      this.fetchUserDeviceContracts();
    }

    if (oldProps.page !== this.props.page) {
      this.fetchUserDeviceContracts();
    }
  }

  fetchUserDeviceContracts() {
    const { fetchUserDeviceContracts, userId, page } = this.props;
    fetchUserDeviceContracts(userId, page);
  }

  render() {
    const { deviceContracts, pageCount, page, userId, viewUrl } = this.props;
    if (!deviceContracts) {
      return <p>Loading...</p>;
    }

    return (
      <div id="device-contracts">
        <UserDeviceContractsList
          deviceContracts={deviceContracts}
          viewUrl={viewUrl}
        />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) =>
            `/users/${userId}/view?deviceContractsPage=${pageNum}`
          }
        />
      </div>
    );
  }
}

export default UserDeviceContracts;
